import React from "react";
import PropTypes from "prop-types";
import { Translate } from "orion-components/i18n";
import { Divider } from "@mui/material";
import AlertAction from "./components/AlertAction";

const styles = {
	container: {
		padding: "18px 14px"
	},
	title: {
		lineHeight: "16px",
		marginBottom: 16
	},
	divider: {
		backgroundColor: "#46484B",
		margin: "14px 0"
	}
};

const AlertActionsWidget = ({ actions, alertTime, alertId, alertAcknowledged }) => {
	return (
		<div style={styles.container} data-testid="alert-actions-widget">
			<div className="cb-font-b2" style={styles.title}>
				<Translate value="global.profiles.widgets.alarmActions.title" />
			</div>
			{actions.map((action, index) => {
				return (
					<React.Fragment key={action.alertActionInstanceId || index}>
						<AlertAction
							action={action}
							alertTime={alertTime}
							alertId={alertId}
							alertAcknowledged={alertAcknowledged}
						/>
						{index !== actions.length - 1 && <Divider style={styles.divider} />}
					</React.Fragment>
				);
			})}
		</div>
	);
};

AlertActionsWidget.propTypes = {
	actions: PropTypes.array.isRequired,
	alertTime: PropTypes.string.isRequired,
	alertId: PropTypes.string.isRequired,
	alertAcknowledged: PropTypes.bool.isRequired
};

export default AlertActionsWidget;
